/**
 * The RevenueCat app user id for a backend user.
 *
 * **UPPERCASE, and this is the highest-risk line in billing.** iOS identifies
 * with `UserResponse.id` as Swift's `UUID.uuidString`, which is uppercase;
 * FastAPI serialises the same UUID lowercase; RevenueCat ids are
 * case-sensitive. Passing the API string through unchanged yields a second,
 * empty RevenueCat customer: purchases work, entitlements never unify with the
 * iOS subscription, and an existing subscriber is charged twice. PRD
 * `00-product-overview.md` §4, M13-R26.
 *
 * It is the backend `id`, not `firebase_uid` (iOS `AuthStateManager.swift:178`).
 */
export function appUserIdFor(userId: string): string {
  return userId.toUpperCase()
}
